import { PayPalButton } from "react-paypal-button-v2";
import React from "react";
import { ModalContext } from "./Modal/modalContext";
import { createCalendarEvent } from "../constants/api-methods";
const paypal_client_id =
  "AQSXrooFuSykJxlotL85gWE_HsKJMDJ-PgXskZ_bInAQKTHFMKg3tvZbJNkPSDvptknpwDK42jxGQFoN";
const createEventName = (sessionType, producerName, artistName) => {
  const splitName = producerName.split(" ");
  return `${splitName[0]} X ${artistName} || ${
    sessionType === "mix" ? "Mix Session" : "Production Session"
  }`;
};
export const PayPalBtn = ({ bookingInfo }) => {
  let { paymentConfirmed, setPaymentConfirmed } = React.useContext(ModalContext);
  return (
    <PayPalButton
      amount={bookingInfo.duration * bookingInfo.hourly_price}
      shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
      onSuccess={(details, data) => {
        setPaymentConfirmed(true);
        createCalendarEvent(
          createEventName(
            bookingInfo.session_type,
            bookingInfo.producer_name,
            bookingInfo.artist_name
          ),
          bookingInfo.start,
          bookingInfo.end,
          bookingInfo.studio_id,
          bookingInfo.user_id,
          bookingInfo.contact_id,
          bookingInfo.session_type,
          bookingInfo.duration,
          bookingInfo.hourly_price
        );

        // OPTIONAL: Call your server to save the transaction
        return fetch("/paypal-transaction-complete", {
          method: "post",
          body: JSON.stringify({
            orderId: data.orderID
          })
        });
      }}
      options={{
        clientId: paypal_client_id
      }}
    />
  );
};
export default PayPalBtn;
